export default __webpack_public_path__ + "static/media/specialrule3.86f0ca08.svg";